import React from 'react';
import styles from './location.module.css';
function Location({ latitude, longitude, address, addressName }) {
  const handleRedirect = () => {
    window.open(`https://www.google.com/maps?q=${latitude},${longitude}&hl=es;z=14`, '_blank');
  };
  return (
    <div className={`${styles.container} rcw-message-content`}>
      <div className={styles.locationMap} >
        <div className={styles.locationMapImage}><img src='./images/map.svg' /></div>
        <div className={styles.locationTextContainer}>
          <p className={styles.imageText} title={addressName}>{addressName}</p>
          <p className={styles.locationAdd} title={address}>{address}</p>
        </div>
      </div>
      <div className={styles.locationLink} onClick={handleRedirect}>
        {`https://www.google.com/maps?q=${latitude},${longitude}&hl=es;z=14`}
      </div>
    </div>
  );
}
export default Location;
